import classnames from 'classnames';
import React from 'react';
import './Icon.scss';

function renderIcon({ className, fill, height = 24, icon, style, width = 24, ...props }) {
    let viewBox = '0 0 24 24';
    let iconPaths = null;

    switch (icon) {
        case 'action-arrow-right':
            iconPaths = (
                <>
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z" />
                </>
            );
            break;
        case 'arrow-up':
            iconPaths = (
                <>
                    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'arrow-right':
            iconPaths = (
                <>
                    <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
                    <path d="M0-.25h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'arrow-down':
            iconPaths = (
                <>
                    <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" />
                    <path d="M0-.75h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'arrow-drop-down':
            iconPaths = (
                <>
                    <path d="M7 10l5 5 5-5z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'arrow-left':
            iconPaths = (
                <>
                    <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" />
                    <path d="M0-.5h24v24H0z" fill="none" />
                </>
            );
            break;
		case 'cancel':
			iconPaths = (
				<>
					{/* <g id="--Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"> */}
						{/* <g id="Group-15" transform="translate(-8.000000, -10.000000)"> */}
							<g id="nofinement" transform="translate(9.000000, 11.000000)">
								<circle id="Oval" stroke="#FAFAFA" cx="5" cy="5" r="5"></circle>
								<line x1="1.5" y1="1.5" x2="8.5" y2="8.5" id="Line-2" stroke="#FFFFFF" strokeLinecap="square"></line>
							</g>
						{/* </g> */}
					{/* </g> */}
				</>
			);
			break;
        case 'car':
            iconPaths = (
                <>
                    <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'calculator':
            iconPaths = (
                <>
                    <path
                        fill="none"
                        stroke={fill}
                        strokeLinejoin="miter"
                        strokeLinecap="butt"
                        strokeMiterlimit="4"
                        strokeWidth="1.7778"
                        d="M2.667 0.889h26.667c0.982 0 1.778 0.796 1.778 1.778v26.667c0 0.982-0.796 1.778-1.778 1.778h-26.667c-0.982 0-1.778-0.796-1.778-1.778v-26.667c0-0.982 0.796-1.778 1.778-1.778z"
                    ></path>
                    <path fill={fill} d="M15.111 1.15h1.778v30.015h-1.778z"></path>
                    <path fill={fill} d="M1.080 16.889v-1.778h30v1.778z"></path>
                    <path fill={fill} d="M9.126 12.4h-0.889v-7.511h0.889z"></path>
                    <path fill={fill} d="M4.879 9.089v-0.889h7.578v0.889z"></path>
                    <path fill={fill} d="M11.283 25.732l-0.629 0.629-5.311-5.311 0.629-0.629z"></path>
                    <path fill={fill} d="M5.939 26.393l-0.629-0.629 5.358-5.358 0.629 0.629z"></path>
                    <path fill={fill} d="M20.267 9.084v-0.889h7.218v0.889z"></path>
                    <path fill={fill} d="M16 16h14.222v14.222h-14.222v-14.222z"></path>
                    <path fill="#fff" d="M20.267 21.884v-0.889h7.218v0.889z"></path>
                    <path fill="#fff" d="M20.267 25.44v-0.889h7.218v0.889z"></path>
                </>
            );
            viewBox = '0 0 32 32';
            break;
        case 'caret-left':
            iconPaths = (
                <>
                    <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" />
                    <path d="M0-.5h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'caret-right':
            iconPaths = (
                <>
                    <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
                    <path d="M0-.25h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'checkmark':
            iconPaths = (
                <>
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </>
            );
            break;
        case 'checkmark-circle':
            iconPaths = (
                <>
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </>
            );
            break;
        case 'clock':
            iconPaths = (
                <>
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" />
                </>
            );
            break;
        case 'close':
            iconPaths = (
                <>
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'circle-close':
            iconPaths = (
                <>
                    <path
                        d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
                        fill="#ffffff"
                    />
                    <path d="M0 0h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'event':
            iconPaths = (
                <>
                    <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'event-available':
            iconPaths = (
                <>
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z" />
                </>
            );
            break;
        case 'filter':
            iconPaths = (
                <path d="M16 17.882v-3.765h15.059v3.765h-15.059zM16 29.176v-3.765h7.529v3.765h-7.529zM16 6.588v-3.765h22.588v3.765h-22.588zM8.471 25.412h4.706l-6.588 6.588-6.588-6.588h4.706v-18.823h-4.706l6.588-6.588 6.588 6.588h-4.706v18.823z"></path>
            );
            viewBox = '0 0 40 32';
            break;
        case 'garbage':
            iconPaths = (
                <>
                    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'garbage-x':
            iconPaths = (
                <>
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'info':
            iconPaths = (
                <>
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
                </>
            );
            break;
        case 'location-pin':
            iconPaths = (
                <>
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'lock':
            iconPaths = (
                <>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"></path>
                </>
            );
            break;
        case 'logo':
            iconPaths = (
                <>
                    <polygon
                        id="Fill-1"
                        fill="#FFD700"
                        points="77.437 38.246 96.751 38.246 96.751 32.599 77.437 32.599"
                    ></polygon>
                    <polygon
                        id="Fill-2"
                        fill="#FFD700"
                        points="102.3 38.246 121.614 38.246 121.614 32.599 102.3 32.599"
                    ></polygon>
                    <polygon
                        id="Fill-3"
                        fill="#FFD700"
                        points="127.167 38.246 146.479 38.246 146.479 32.599 127.167 32.599"
                    ></polygon>
                    <polygon
                        id="Fill-4"
                        fill="#FFD700"
                        points="152.032 38.246 171.347 38.246 171.347 32.599 152.032 32.599"
                    ></polygon>
                    <polygon
                        id="Fill-5"
                        fill="#FFD700"
                        points="176.898 38.246 195.615 38.246 195.615 32.598 176.898 32.598"
                    ></polygon>
                    <path
                        d="M77.4288,25.3544 L87.3918,25.3544 L87.3918,10.0044 C87.3918,8.0434 88.2568,7.2584 89.2018,7.2584 C90.1498,7.2584 90.9308,8.1904 90.9308,9.9074 L90.9308,25.3544 L100.8928,25.3544 L100.8928,10.0044 C100.8928,8.0434 101.7558,7.2584 102.7038,7.2584 C103.6518,7.2584 104.4318,8.1904 104.4318,9.9074 L104.4318,25.3544 L114.3958,25.3544 L114.3958,8.9754 C114.3958,2.4524 111.3888,0.0004 107.2338,0.0004 C104.8848,0.0004 102.4138,0.9324 100.7268,4.4634 C99.4518,1.4224 97.1478,0.0004 93.9778,0.0004 C91.6318,0.0004 89.1608,0.9324 87.4738,4.4634 L87.3918,4.4634 L87.1458,0.7374 L77.4288,0.7374 L77.4288,25.3544 Z"
                        id="Fill-6"
                        fill="#003366"
                    ></path>
                    <path
                        d="M15.046,16.2294 C14.909,18.8274 14.056,19.5794 12.79,19.5794 C10.331,19.5794 10.126,16.7784 10.126,13.0174 C10.126,9.0534 10.364,6.4564 12.894,6.4564 C14.089,6.4564 15.114,7.0044 15.251,9.8054 L24.206,9.8054 C24.171,2.5604 18.909,0.0304 12.689,0.0304 C4.349,0.0304 -0.229,5.2254 0.009,12.9154 C0.009,20.7424 4.007,26.0044 12.655,26.0044 C18.773,26.0044 24.206,23.0314 24.206,16.2294 L15.046,16.2294 Z"
                        id="Fill-8"
                        fill="#003366"
                    ></path>
                    <path
                        d="M52.214,25.3544 L61.769,25.3544 L61.769,16.5844 L62.896,16.5844 C64.466,16.5844 65.079,17.0624 65.284,18.2914 C65.626,20.4074 65.261,19.8324 66.152,25.3544 L75.706,25.3544 C75.237,20.8654 75.011,18.1554 74.464,16.0394 C73.985,14.1614 72.689,13.1024 70.3,12.8994 C73.985,11.9434 75.181,9.7934 75.181,6.9594 C75.181,2.3194 72.075,0.7154 66.786,0.7154 L52.214,0.7154 L52.214,25.3544 Z M61.769,10.9874 L61.769,6.3124 L62.657,6.3124 C64.568,6.3124 65.831,6.6884 65.831,8.4974 C65.831,10.3404 64.466,10.9874 62.589,10.9874 L61.769,10.9874 Z"
                        id="Fill-10"
                        fill="#003366"
                    ></path>
                    <path
                        d="M23.1534,25.3544 L32.5164,25.3544 L33.5084,21.3904 L40.5834,21.3904 L41.5404,25.3544 L51.6554,25.3544 L43.7274,0.6804 L31.0484,0.6804 L23.1534,25.3544 Z M34.9774,15.3754 L37.1304,6.0814 L39.1474,15.3754 L34.9774,15.3754 Z"
                        id="Fill-12"
                        fill="#003366"
                    ></path>
                    <polygon
                        id="Fill-14"
                        fill="#003366"
                        points="160.0518 25.3339 170.0648 25.3339 163.1998 12.1579 168.7888 0.8369 158.3558 0.8369 155.5828 8.6289 152.2378 0.8369 141.8058 0.8369 147.8798 12.1579 141.2178 25.3339 151.3428 25.3339 155.5828 16.3429"
                    ></polygon>
                    <path
                        d="M172.711,0.7841 C173.997,0.7841 174.984,1.8351 174.984,3.0591 C174.984,4.3291 173.969,5.3551 172.711,5.3551 C171.468,5.3551 170.436,4.3451 170.436,3.0591 C170.436,1.8071 171.468,0.7841 172.711,0.7841 L172.711,0.7841 Z M172.711,0.4761 C171.33,0.4761 170.13,1.6101 170.13,3.0591 C170.13,4.5081 171.318,5.6551 172.711,5.6551 C174.118,5.6551 175.293,4.5081 175.293,3.0591 C175.293,1.6241 174.131,0.4761 172.711,0.4761 L172.711,0.4761 Z M172.149,1.9791 L172.751,1.9791 C172.957,1.9791 173.3,1.9791 173.3,2.4171 C173.3,2.8411 172.943,2.8411 172.751,2.8411 L172.149,2.8411 L172.149,1.9791 Z M171.768,4.4261 L172.149,4.4261 L172.149,3.1691 L172.627,3.1691 C173.079,3.1691 173.189,3.2781 173.23,3.7021 C173.284,4.1381 173.311,4.2471 173.365,4.4261 L173.763,4.4261 C173.667,4.1521 173.639,3.8931 173.598,3.5521 C173.557,3.2081 173.464,3.0871 173.175,3.0181 C173.693,2.8681 173.693,2.4301 173.693,2.3481 C173.693,1.6511 172.957,1.6511 172.751,1.6511 L171.768,1.6511 L171.768,4.4261 Z"
                        id="Fill-16"
                        fill="#003366"
                    ></path>
                    <path
                        d="M130.9727,10.1064 L129.5977,10.1064 C120.6767,10.1064 115.9317,12.5954 115.9317,18.6474 C115.9317,23.4794 119.3477,26.1154 124.1887,26.1154 C126.7997,26.1154 129.3137,25.2854 130.9727,23.0394 L131.2737,25.3544 L141.3437,25.3394 L141.3187,8.8384 C141.3187,3.1294 138.3767,0.1514 129.2187,0.1514 C123.1927,0.1514 117.3067,1.5674 116.9277,8.1554 L126.4177,8.1554 C126.5607,6.1064 127.3217,5.6184 128.7447,5.6184 C130.3587,5.6184 130.9727,6.3494 130.9727,7.5694 L130.9727,10.1064 Z M130.9547,16.8744 C130.9547,18.8754 130.3387,20.1914 128.3437,20.1914 C126.5887,20.1914 125.6887,19.2154 125.6887,17.6544 C125.6887,16.2884 126.3517,14.8234 129.3887,14.8234 L130.9547,14.8234 L130.9547,16.8744 Z"
                        id="Fill-18"
                        fill="#003366"
                    ></path>
                </>
            );
            viewBox = '0 0 196 32';

            break;
        case 'money':
            iconPaths = (
                <>
                    <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'new':
            iconPaths = (
                <>
                    <defs>
                        <path d="M0 0h24v24H0V0z" id="a" />
                    </defs>
                    <clipPath id="b">
                        <use overflow="visible" xlinkHref="#a" />
                    </clipPath>
                    <path
                        clipPath="url(#b)"
                        d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM8.5 15H7.3l-2.55-3.5V15H3.5V9h1.25l2.5 3.5V9H8.5v6zm5-4.74H11v1.12h2.5v1.26H11v1.11h2.5V15h-4V9h4v1.26zm7 3.74c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V9h1.25v4.51h1.13V9.99h1.25v3.51h1.12V9h1.25v5z"
                    />
                </>
            );
            break;
        case 'new-releases':
            iconPaths = (
                <>
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z" />
                </>
            );
            break;
        case 'notification':
            iconPaths = (
                <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
            );
            break;
        case 'notification-active':
            iconPaths = (
                <>
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z" />
                </>
            );
            break;
        case 'notification-off':
            iconPaths = (
                <>
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z" />
                </>
            );
            break;
        case 'phone':
            iconPaths = (
                <>
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                </>
            );
            break;
        case 'question-circle':
            iconPaths = (
                <path d="M16 0c-8.832 0-16 7.168-16 16s7.168 16 16 16c8.832 0 16-7.168 16-16s-7.168-16-16-16zM17.6 27.2h-3.2v-3.2h3.2v3.2zM20.912 14.8l-1.44 1.472c-1.152 1.168-1.872 2.128-1.872 4.528h-3.2v-0.8c0-1.76 0.72-3.36 1.872-4.528l1.984-2.016c0.592-0.576 0.944-1.376 0.944-2.256 0-1.76-1.44-3.2-3.2-3.2s-3.2 1.44-3.2 3.2h-3.2c0-3.536 2.864-6.4 6.4-6.4s6.4 2.864 6.4 6.4c0 1.408-0.576 2.688-1.488 3.6z"></path>
            );
            viewBox = '0 0 32 32';
            break;
        case 'textsms':
            iconPaths = (
                <>
                    <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'trend-up':
            iconPaths = (
                <>
                    <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'trend-down':
            iconPaths = (
                <>
                    <path d="M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                </>
            );
            break;
        case 'warning':
            iconPaths = (
                <>
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
                </>
            );
            break;
        case 'ellipsis-vertical':
            iconPaths = (
                <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12ZM12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21Z"
                        fill="currentColor"
                    ></path>
            );
            break;
    }

    return (
        <span className="svg-icon">
            <svg
                className={classnames(['kmx-icon', className])}
                fill={fill}
                height={height}
                style={style}
                viewBox={viewBox}
                aria-hidden="true"
                focusable="false"
                width={width}
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                {iconPaths}
            </svg>
        </span>
    );
}

export default renderIcon;
